/**
 * 简体中文翻译——书籍与规则/战役功能的文案库
 * (`@gamecodex/world-ui` → `features/books`)。
 *
 * 键对应特性中 React 组件的 `t('books.*')` 调用。值为
 * i18n 清点期间提取的原始英文字符串的本地化版本。
 */
export const booksZhCN = {
  // BackerDownloadModal.tsx
  'books.backerModal.title': '领取您的支持者 PDF',
  'books.backerModal.sendLinkError': '现在无法发送您的登录链接。请稍后重试。',
  'books.backerModal.checkInboxPrefix': '检查您在此处的收件箱',
  'books.backerModal.checkInboxSuffix':
    '如果您用该邮箱进行过支持，登录链接正在路上——点击它来领取您的副本。',
  'books.backerModal.linkAutoSignIn': '该链接在本站打开，并自动为您登录。无需密码。',
  'books.backerModal.signInIntro':
    '输入您支持时用的邮箱。我们将发送一个一键登录链接，然后为您准备个人副本。',
  'books.backerModal.pledgeEmailLabel': '支持账户邮箱',
  'books.backerModal.emailLinkCta': '发送登录链接至我的邮箱',
  'books.backerModal.prepareTimeout':
    '您的副本准备时间超过预期。请在几分钟后重试。',
  'books.backerModal.notEntitled': '您已登录，但您的支持资格不包含此书。',
  'books.backerModal.notClaimable': '此书不提供支持者下载。',
  'books.backerModal.prepareError': '现在无法为您准备下载。请稍后重试。',
  'books.backerModal.signedInAs': '登录身份为',
  'books.backerModal.signOut': '登出',
  'books.backerModal.verified': '已验证',
  'books.backerModal.welcomeBack': ' ——欢迎回来，',
  'books.backerModal.backerNumber': '（支持者 #{number}）',
  'books.backerModal.copyReady':
    '您的个人副本已准备好。此链接为个人专属，即将过期——请勿分享。',
  'books.backerModal.downloadPdf': '下载您的 PDF',
  'books.backerModal.dtrpgEmailLabel': 'DriveThruRPG 账户邮箱',
  'books.backerModal.optional': '（可选）',
  'books.backerModal.dtrpgWarn':
    '添加此项还可将购买镜像到您的 DriveThruRPG 库。跳过此项，您的副本仍可在此处下载。',
  'books.backerModal.preparingCopy': '正在为您准备副本……',
  'books.backerModal.prepareDownload': '准备并下载',

  // BackerVerifyPage.tsx
  'books.backerVerify.missingToken': '此登录链接缺少令牌。请从书籍页面请求新链接。',
  'books.backerVerify.invalidToken':
    '此登录链接无效或已过期。请从书籍页面请求新链接。',
  'books.backerVerify.seoTitle': '支持者登录',
  'books.backerVerify.seoDescription': '正在验证您的 Grymwyrd 支持者登录链接。',
  'books.backerVerify.confirming': '正在确认您的支持者登录……',
  'books.backerVerify.signedInHeading': '您已登录',
  'books.backerVerify.signedInAs': '登录身份为',
  'books.backerVerify.headBackPrefix': '返回该书，点击',
  'books.backerVerify.downloadWord': '下载',
  'books.backerVerify.headBackSuffix': '来领取您的副本。',
  'books.backerVerify.backToBook': '返回您的书籍',
  'books.backerVerify.browseAthenaeum': '浏览藏书库',
  'books.backerVerify.problemHeading': '登录链接问题',

  // BookCard.tsx
  'books.card.viewAria': '查看 {title}',
  'books.card.coverAlt': '{title} 的封面',
  'books.card.owned': '已拥有',

  // BookCover.tsx
  'books.cover.coverAlt': '{title} 的封面',

  // BookStorePage.tsx
  'books.store.seoTitle': '书籍与规则',
  'books.store.seoDescription':
    '永恒暮光之书——核心规则书、插图 SRD 与暗黑冒险。购买以解锁模块并赚取游戏币。',
  'books.store.eyebrow': '藏书库',
  'books.store.heading': '书籍与规则',
  'books.store.intro':
    '获取结合世界的典籍。每次购买都会解锁您战役中的可玩模块，并用游戏内经济的游戏币奖励您。',
  'books.store.filterAria': '按类型筛选书籍',
  'books.store.filterAll': '全部',
  'books.store.loading': '正在启封档案库……',
  'books.store.empty': '此类别尚无匹配的典籍。抄写员们仍在工作中。',

  // BuyButton.tsx
  'books.buy.checkoutUnavailable': '结账暂未开放。请稍后重试。',
  'books.buy.signInToClaim': '登录以领取此部典籍。',
  'books.buy.ledgerSealed': '商人的账簿暂时已封——结账即将推出。',
  'books.buy.inLibrary': '在您的库中',
  'books.buy.openingVault': '正在打开金库……',
  'books.buy.claimFree': '免费领取',
  'books.buy.buyPrice': '购买 ——{price}',
  'books.buy.unlockPrefix': '购买 → 解锁模块 +',
  'books.buy.coinsSuffix': '{coins} 金币',

  // BookDetailPage.tsx
  'books.detail.loading': '正在翻动书页……',
  'books.detail.backToAthenaeum': '返回藏书库',
  'books.detail.unlockOwned': '您拥有此部典籍——其 Grymwyrd 背景知识已在全百科中解锁。',
  'books.detail.unlockClaim': '领取此部典籍以在全百科中解锁其 Grymwyrd 背景知识。',
  'books.detail.returnTo': '返回至 {label}',
  'books.detail.backerCta': '是支持者？下载您的 PDF',
  'books.detail.coinsEarned': '您从此次购买获得了 {coins} 金币。',
  'books.detail.coinsGranted': '购买向您的金币库授予 {coins} 金币。',
  'books.detail.byAuthor': '{author} 著',
  'books.detail.statPrice': '价格',
  'books.detail.statPages': '页数（最后渲染）',
  'books.detail.statWords': '字数（最后渲染）',
  'books.detail.ofThisTome': '此典籍的数据',
  'books.detail.noDescription': '此卷还未有任何描述。',
  'books.detail.previewHeading': '预览',
  'books.detail.previewBlurb': '在领取此书前先睹为快。',
  'books.detail.readPreview': '阅读预览',
  'books.detail.tocHeading': '目录',
  'books.detail.tocEmpty': '此典籍的目录尚未编制。',
  'books.detail.pageAbbrev': '第 {page} 页',
  'books.detail.unlockedHeading': '已解锁的百科条目',
  'books.detail.unlockedOwnedNote': '现为您的活百科的一部分：',
  'books.detail.unlockedLockedNote':
    '购买此典籍将其生物、法术和秘密铭刻到您的百科中——并获得',
  'books.detail.coinsAmount': '{coins} 金币',
  'books.detail.attributionsHeading': '致谢与许可',
  'books.detail.attributionSource': '来源',
  'books.detail.attributionLink': '链接',

  // CampaignLandingPage.tsx
  'books.campaign.liveCampaign': '进行中的战役',
  'books.campaign.backThisProject': '支持此项目',
  'books.campaign.viewStretchGoals': '查看拉伸目标',
  'books.campaign.pledged': '已支持',
  'books.campaign.backers': '支持者',
  'books.campaign.pitchHeading': '项目介绍',
  'books.campaign.backerUnlockedHeading': '支持者解锁条目',
  'books.campaign.backerUnlockedBlurb':
    '支持者可以抢先获取流入活百科的内容。这是已成为正史的内容的样本：',
  'books.campaign.previewsEmpty': '新正史正在铭刻中——在目标解锁时返回查看。',
  'books.campaign.choosePledge': '选择您的支持',
  'books.campaign.mostBacked': '最多支持',
  'books.campaign.pledgeAmount': '支持 {amount}',
  'books.campaign.pledgeFooter':
    '支持在结账时安全处理。支持奖励（金币、模块和百科解锁）在战役服务上线后授予您的 Grymwyrd 账户。',

  // LanguageSelect.tsx
  'books.language.label': '语言',

  // PreviewModal.tsx
  'books.preview.title': '预览 —— {title}',
  'books.preview.pdfAria': '{title} 的预览 PDF',
  'books.preview.cannotDisplay': '您的设备无法内联显示预览。',
  'books.preview.openNewTab': '在新标签页中打开预览',
  'books.preview.preparingHeading': '预览正在准备中。',
  'books.preview.preparingBody':
    '此书的样本正由抄写室铭刻，不久将显示在此处。同时，一睹其中的内容：',
  'books.preview.excerptLabel': '摘录 —— {title}',
  'books.preview.excerptFallback':
    '超越此阈值的页面浸满了恐惧与奇迹。获取典籍以继续阅读。',
  'books.preview.noExcerpt': '此卷尚未编制任何摘录。',

  // RulesPage.tsx
  'books.rules.sectionSpells': '法术',
  'books.rules.sectionMonsters': '怪物',
  'books.rules.sectionMagicItems': '魔法物品',
  'books.rules.sectionWeapons': '武器',
  'books.rules.sectionArmor': '护甲',
  'books.rules.sectionSkills': '技能',
  'books.rules.entriesCount': '{entries} 条目',
  'books.rules.readingLabel': '正在阅读 {label}……',
  'books.rules.noneCatalogued': '此系统中还未编制任何 {label}。',
  'books.rules.browseAll': '在百科中浏览全部 {label} →',
  'books.rules.seoTitle': '规则 & SRD',
  'books.rules.seoDescription':
    '浏览系统参考文档——法术、怪物、物品与系统规则。现有 5e SRD，更多系统即将推出。',
  'books.rules.eyebrow': '法典',
  'books.rules.heading': '规则与系统参考',
  'books.rules.intro':
    'Grymwyrd 所用的开放游戏内容。浏览规则相关条目，深入完整百科查看数值和背景。Grymwyrd 现提供 5e SRD ——PF2e 和其他系统即将推出。',
  'books.rules.loading': '正在查阅法典……',
  'books.rules.gameSystems': '游戏系统',
  'books.rules.noSystems': '尚未注册任何游戏系统。',
  'books.rules.openSrd': '打开 SRD',
  'books.rules.lockedComingSoon': '已锁定——即将推出',
  'books.rules.referenceContent': '{name} —— 参考内容',
  'books.rules.releasedUnder': '发布于 {license}',
  'books.rules.licenseLink': '许可',

  // StretchGoals.tsx
  'books.stretch.goalProgressAria': '{title} 的众筹进度',
  'books.stretch.unlockedAdded': '已解锁——已添加到百科',
  'books.stretch.percentFunded': '{pct}% 已资助',
  'books.stretch.autoPopulates': '自动填充百科',
  'books.stretch.raisedSoFar': '迄今筹集',
  'books.stretch.backers': '支持者',
  'books.stretch.overallAria': '总体众筹进度',
  'books.stretch.heading': '拉伸目标',
} as const
